export default __webpack_public_path__ + "static/media/bg-tile-2.e298b37f.webp";